export class HttpError extends Error {
  constructor(message: string, response?: Response) {
    super(message);
    this.response = response;
  }

  readonly response;
}
